import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {FormattedMessage} from "@irati/utils/lang"
import {Dropzone} from "@irati/ui/src/Layout"
import {H4} from "@irati/ui/src/Typography/Heading"
import ImageEditor from "@irati/ui/src/ImageEditor"
import {PROFILE_IMAGE_SIZE} from "@irati-web/platform/src/constants/profile"
import {hasProfileImageChanged} from "@irati/images/helpers/changeProfilePic"

const IMAGE_EDITOR_PADDING = 70

const UnderlineStrong = styled.strong`
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }
`

class Editor extends PureComponent {
  static propTypes = {
    initialImage: PropTypes.string
  }

  static defaultProps = {
    initialImage: null
  }

  constructor(props) {
    super(props)
    this.state = {
      scale: 1,
      img: props.initialImage
    }
  }

  getImage = () => {
    const {img} = this.state
    if (!hasProfileImageChanged(img)) {
      return img
    } else if (this.editor) {
      return this.editor.getImage().toDataURL()
    }
  }

  setImage = (img) => {
    this.setState({img})
  }

  handleRescale = (scale) => {
    this.setState({scale})
  }

  handleDrop = (accepted) => {
    this.setState({img: accepted[0]})
  }

  render() {
    const {img, scale} = this.state
    const {initialImage} = this.props

    if (!img) {
      return (
        <Dropzone
          accept="image/jpg,image/jpeg,image/png"
          multiple={false}
          onDrop={this.handleDrop}>
          <H4>
            <FormattedMessage
              id="account.editProfile.editor.headerFour.dropZone.text"
              values={{
                browse: <UnderlineStrong>
                  <FormattedMessage
                    id="account.editProfile.editor.headerFour.dropZone.browse" />
                </UnderlineStrong>
              }} />
          </H4>
        </Dropzone>
      )
    }

    const showSlider = initialImage !== img

    return (
      <ImageEditor
        ref={(c) => { this.editor = c }}
        image={img}
        showSlider={showSlider}
        width={PROFILE_IMAGE_SIZE * 2}
        height={PROFILE_IMAGE_SIZE * 2}
        border={IMAGE_EDITOR_PADDING}
        borderRadius={PROFILE_IMAGE_SIZE}
        color={[0, 0, 0, 0.8]}
        scale={scale}
        landscapeIcon
        onUpdate={this.handleRescale}
        style={{
          width: PROFILE_IMAGE_SIZE + IMAGE_EDITOR_PADDING,
          height: PROFILE_IMAGE_SIZE + IMAGE_EDITOR_PADDING
        }} />
    )
  }
}

export default Editor
